// Auto generated file, do not manually modify!
// com.hotpads.rins.api.web.handler.ProofOfInsuranceWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  CreateAndShareProofWebApiRequestDto,
  EmailRequestResultDto,
  GetProofStatusWebApiRequestDto,
  GetProofStatusWebApiResponseDto,
  GetTenantsListWebApiRequestDto,
  GetTenantsListWebApiResponseDto,
  SendProofRequestWebApiRequestDto,
  ValidateRenterProofAndLinkZuidWebApiRequestDto,
} from '../..';

export const ProofOfInsuranceWebApiHandler_createAndShareProof_Path =
  '/api/web/v1/proofOfInsurance/createAndShareProof';

/**
 * create proof of insurance with zDoc document ID,share proof of insurance and notify email recipient
 */
export const ProofOfInsuranceWebApiHandler_createAndShareProof = (
  postData: CreateAndShareProofWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, CreateAndShareProofWebApiRequestDto, void>(
    {
      endpoint: ProofOfInsuranceWebApiHandler_createAndShareProof_Path,
      method: 'POST',
      contextPath: '/rins',
      postData: postData,
    },
    client,
  );
};

export const ProofOfInsuranceWebApiHandler_getProofStatus_Path = '/api/web/v1/proofOfInsurance/getProofStatus';

/**
 * get proof of insurance state for tenant
 */
export const ProofOfInsuranceWebApiHandler_getProofStatus = (
  postData: GetProofStatusWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, GetProofStatusWebApiRequestDto, GetProofStatusWebApiResponseDto>(
    {
      endpoint: ProofOfInsuranceWebApiHandler_getProofStatus_Path,
      method: 'POST',
      contextPath: '/rins',
      postData: postData,
    },
    client,
  );
};

export const ProofOfInsuranceWebApiHandler_getTenantsList_Path = '/api/web/v1/proofOfInsurance/getTenantsList';

/**
 * Get a list of tenants with the request status
 */
export const ProofOfInsuranceWebApiHandler_getTenantsList = (
  postData: GetTenantsListWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, GetTenantsListWebApiRequestDto, GetTenantsListWebApiResponseDto>(
    {
      endpoint: ProofOfInsuranceWebApiHandler_getTenantsList_Path,
      method: 'POST',
      contextPath: '/rins',
      postData: postData,
    },
    client,
  );
};

export const ProofOfInsuranceWebApiHandler_sendProofRequestEmail_Path =
  '/api/web/v1/proofOfInsurance/sendProofRequestEmail';

/**
 * Send an email reminder to Rachels to upload their proof of insurance
 */
export const ProofOfInsuranceWebApiHandler_sendProofRequestEmail = (
  postData: SendProofRequestWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SendProofRequestWebApiRequestDto, EmailRequestResultDto>(
    {
      endpoint: ProofOfInsuranceWebApiHandler_sendProofRequestEmail_Path,
      method: 'POST',
      contextPath: '/rins',
      postData: postData,
    },
    client,
  );
};

export const ProofOfInsuranceWebApiHandler_validateRenterProofAndLinkZuid_Path =
  '/api/web/v1/proofOfInsurance/validateRenterProofAndLinkZuid';

/**
 * Validate proof request to renter info, and links ZUID to the proof request if needed
 */
export const ProofOfInsuranceWebApiHandler_validateRenterProofAndLinkZuid = (
  postData: ValidateRenterProofAndLinkZuidWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, ValidateRenterProofAndLinkZuidWebApiRequestDto, void>(
    {
      endpoint: ProofOfInsuranceWebApiHandler_validateRenterProofAndLinkZuid_Path,
      method: 'POST',
      contextPath: '/rins',
      postData: postData,
    },
    client,
  );
};
